import './index.css';

const ICP = () => {
    return (
        <div className="icp">
            <a href="http://beian.miit.gov.cn" target="_blank" rel="noreferrer">沪ICP备2022028303号-1</a>
        </div>
    )
};

export default ICP;